var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.tabActive),callback:function ($$v) {_vm.tabActive=$$v},expression:"tabActive"}},_vm._l((_vm.data.tabList),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":item.text,"name":'' + index}},[_c('l-form-wraper',{attrs:{"myComponents":item.children}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }